import { NavLink } from "react-router-dom";

import { useNotifications } from "../api/notifications";
import { useAuth } from "../auth/AuthProvider";
import Icon from "../components/Icon";

interface AccountNavButtonProps {
  variant: "tab" | "wide";
}

export default function AccountNavButton({ variant }: AccountNavButtonProps) {
  const { isAuthenticated, me } = useAuth();
  const notifications = useNotifications({ enabled: isAuthenticated });
  const unread = notifications.data?.unread ?? 0;
  const badge = unread > 99 ? "99+" : String(unread);
  const displayName = me?.username ?? "Log in";
  const label =
    unread > 0
      ? `${displayName}, ${unread} unread notifications`
      : displayName;
  const to = isAuthenticated ? "/account" : "/login";

  if (variant === "wide") {
    return (
      <NavLink
        to={to}
        aria-label={label}
        className={({ isActive }) =>
          "nav-item nav-item--user account-nav account-nav--wide" +
          (isActive ? " nav-item--active" : "")
        }
      >
        <span className="account-nav__icon-wrap">
          <Icon name="user" className="nav-item__icon" />
          {unread > 0 ? (
            <span className="account-nav__badge">{badge}</span>
          ) : null}
        </span>
        <span className="nav-item__label">{displayName}</span>
      </NavLink>
    );
  }

  return (
    <NavLink
      to={to}
      aria-label={label}
      className={({ isActive }) =>
        "tab-bar__item account-nav account-nav--tab" +
        (isActive ? " tab-bar__item--active" : "")
      }
    >
      <span className="account-nav__icon-wrap">
        <Icon name="user" className="tab-bar__icon" />
        {unread > 0 ? <span className="account-nav__badge">{badge}</span> : null}
      </span>
    </NavLink>
  );
}
